import React, {FC} from 'react';
import styled from 'styled-components';

import {useLocalize} from '../../../../../libs/shared/core/src/helpers/internationalization/internationalizationContext';
import {defineMessage, Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {useInitialEffect} from '../../../../../libs/shared/core/src/helpers/react/hooks/useEffectHelpers';
import {
  InterfaceEventsEnum,
  trackInterfaceEvent,
} from '../../../../../libs/shared/core/src/services/tracking/tracking';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {center} from '../../../../../libs/shared/ui/src/styles/mixins';
import bulkLimit from '../../../../assets/images/bulkLimit.png';

/*
 * Style.
 */

const StyledViewerDiv = styled.div`
  grid-row: 1 / span 4;
  grid-column: 1;
  ${center()};
`;

const StyledImage = styled.img`
  width: 92px;
  height: 67px;
`;

const StyledViewerHeaderDiv = styled.div`
  color: ${(p) => p.theme.greys.shade80};
  font-size: ${fontSizes.veryLarge};
  font-weight: ${fontWeights.bold};
  line-height: 28px;
  padding: 30px 0 8px;
`;

const StyledViewerBodyDiv = styled.div`
  text-align: center;
  color: ${(p) => p.theme.greys.shade80};
  font-size: ${fontSizes.medium};
  line-height: 150%;
`;

/*
 * Component.
 */

export const BulkActionsDisabledViewerContent: FC = () => {
  const localize = useLocalize();
  useInitialEffect(() => {
    trackInterfaceEvent(InterfaceEventsEnum.P3_MULTI_SELECT_MODAL_WARNING_DISPLAYED, {
      type: 'action_limit',
    });
  });

  return (
    <StyledViewerDiv>
      <StyledImage
        draggable={false}
        src={bulkLimit}
        alt={localize(
          defineMessage({
            id: 'viewer-bulkactionlimit',
            message: 'Mass action limit',
          }),
        )}
      />
      <StyledViewerHeaderDiv>
        <Trans id="viewer-bulkactionlimit">Mass action limit</Trans>
      </StyledViewerHeaderDiv>
      <StyledViewerBodyDiv>
        <Trans id="viewer-bulkactionlimit-description">
          You can only perform one mass action at a time.
          <br />
          Please wait for your other mass action to complete.
        </Trans>
      </StyledViewerBodyDiv>
    </StyledViewerDiv>
  );
};
